import { Model } from 'modules/core/lib/mobx-rest'

interface IIncidenceDetail {
  [key: string]: any
}

class IncidenceDetail extends Model<IIncidenceDetail> {}

export default IncidenceDetail
